import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SiAccordionComponent, SiCollapsiblePanelComponent } from '@siemens/element-ng/accordion';
import { ContentWrapperComponent } from '../../shared/components';
import { faqConfig } from '../../shared/configs/faq.config';

@Component({
    selector: 'tran-faq',
    imports: [SiAccordionComponent, SiCollapsiblePanelComponent, TranslatePipe, ContentWrapperComponent],
    templateUrl: './faq.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqComponent {
    protected readonly faqSections = faqConfig;
}
